import {Directive} from '@angular/core';

@Directive({
  selector: '[uiFormContainerButton]'
})
export class FormContainerButtonDirective {}
